<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table
      :data="consultPrice"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="编号" width="155">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Code }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="标题">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Title }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="OrgName" label="所属机构"></el-table-column>
      <el-table-column label="生效日期" width="350">
        <template slot-scope="scope">
          <p>{{ scope.row.DateStart }} 至 {{ scope.row.DateEnd }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注"></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        sortable
      ></el-table-column>
      <el-table-column prop="CreateUser" label="创建者"></el-table-column>
      <el-table-column prop="Status" label="状态" width="">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.Status == 0 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
          <el-link
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleHistry();
              }
            "
          >
            历史
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="所属机构" prop="OrgName">
          <el-input
            v-model="editForm.ConsultPrice.OrgName"
            readonly
            class="hr-select"
          >
            <template slot="append">
              <el-button
                class="pd-5"
                type="primary"
                @click="visibleDialog = true"
              >
                选择
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="标题" prop="Title">
          <el-input v-model="editForm.ConsultPrice.Title" />
        </el-form-item>
        <el-form-item label="自编号" prop="Code">
          <el-input v-model="editForm.ConsultPrice.Code" />
        </el-form-item>
        <el-form-item label="生效开始时间">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="editForm.ConsultPrice.DateStart"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="生效结束时间">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="editForm.ConsultPrice.DateEnd"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="更新强度等级" prop="IsUpdateGradePrice">
              <el-switch
                v-model="editForm.ConsultPrice.IsUpdateGradePrice"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="更新特殊材料" prop="IsUpdateSpecMtlPrice">
              <el-switch
                v-model="editForm.ConsultPrice.IsUpdateSpecMtlPrice"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              label="更新浇筑方式"
              prop="IsUpdatePouringMethodPrice"
            >
              <el-switch
                v-model="editForm.ConsultPrice.IsUpdatePouringMethodPrice"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-col :span="12">
              <el-input
                placeholder="泵送价格"
                v-model="usePumpItemValue"
              ></el-input>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" @click="changePumpItemValue()">
                调整
              </el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-form-item label="基础价格">
          <el-row :gutter="5">
            <el-col
              :span="7"
              v-for="item in consultPriceBaseData"
              v-bind:key="item.DataType"
            >
              <p style="margin: 0">
                {{
                  item.DataType == 0
                    ? "强度等级"
                    : item.DataType == 10
                    ? "特殊材料"
                    : "浇筑方式"
                }}
              </p>
              <el-table :data="item.PriceSubDataBase" border>
                <el-table-column
                  prop="DataName"
                  label="产品名称"
                ></el-table-column>
                <el-table-column prop="DataType" label="单位"></el-table-column>
                <el-table-column label="单价(￥)">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.Price"
                      placeholder="请输入价格"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="editForm.ConsultPrice.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select
            v-model="editForm.ConsultPrice.Status"
            placeholder="请选择状态"
          >
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      width="70%"
    >
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <!-- <el-form-item label="所属机构" prop="OrgName">
          <el-input
            v-model="addForm.ConsultPrice.OrgCode"
            class="input-dialogname"
            width="300px"
            readonly
          />
          <el-button
            type="primary"
            @click="visibleDialog = true"
            :loading="editLoading"
          >
            选择
          </el-button>
        </el-form-item> -->

        <el-form-item label="所属机构" prop="OrgName">
          <el-input
            v-model="addForm.ConsultPrice.OrgName"
            readonly
            class="hr-select"
          >
            <template slot="append">
              <el-button
                class="pd-5"
                type="primary"
                @click="visibleDialog = true"
              >
                选择
              </el-button>
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="标题" prop="Title">
          <el-input v-model="addForm.ConsultPrice.Title" />
        </el-form-item>
        <el-form-item label="自编号" prop="Code">
          <el-input v-model="addForm.ConsultPrice.Code" />
        </el-form-item>
        <el-form-item label="生效开始时间">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="addForm.ConsultPrice.DateStart"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="生效结束时间">
          <el-date-picker
            type="datetime"
            placeholder="选择日期"
            v-model="addForm.ConsultPrice.DateEnd"
            value-format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="泵送价格调整">
          <el-col :span="12">
            <el-input
              placeholder="泵送价格"
              v-model="usePumpItemValue"
            ></el-input>
          </el-col>
          <el-col :span="12">
            <el-button type="primary" @click="changePumpItemValue()">
              调整
            </el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="基础价格">
          <el-row :gutter="5">
            <el-col
              :span="7"
              v-for="item in consultPriceBaseData"
              v-bind:key="item.DataType"
            >
              <p style="margin: 0">
                {{
                  item.DataType == 0
                    ? "强度等级"
                    : item.DataType == 10
                    ? "特殊材料"
                    : "浇筑方式"
                }}
              </p>
              <el-table :data="item.PriceSubDataBase" border>
                <el-table-column
                  prop="DataName"
                  label="产品名称"
                ></el-table-column>
                <!-- <el-table-column prop="DataType" label="单位"></el-table-column> -->
                <el-table-column label="单价(￥)">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.Price"
                      placeholder="请输入内容"
                    ></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            type="textarea"
            v-model="addForm.ConsultPrice.Remark"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
    <!-- 历史报价单列表 -->
    <el-dialog
      title="历史报价单列表"
      :visible.sync="histryShow"
      v-model="histryShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <!--历史列表-->
      <el-table
        :data="histryData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column label="编号" width="155">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.Code }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="PriceVer"
          label="版本号"
          sortable
        ></el-table-column>
        <el-table-column
          prop="CreateUser"
          label="创建人"
          sortable
        ></el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          sortable
        ></el-table-column>
      </el-table>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="histrypageSize"
        :total="histrytotal"
        @current-change="histryCurrentChange"
        @size-change="histrySizeChange"
        class="my-pagination"
      ></el-pagination>
    </el-dialog>
    <!-- 报价单详情 -->
    <el-dialog
      :title="ConsultPriceDetail.ConsultPrice.Title"
      :visible.sync="isShowConsultPriceDetailPage"
      width="70%"
    >
      <el-form :model="ConsultPriceDetail" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="标题">
              {{ ConsultPriceDetail.ConsultPrice.Title }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="自编号">
              {{ ConsultPriceDetail.ConsultPrice.Code }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="生效开始时间">
              {{ ConsultPriceDetail.ConsultPrice.DateStart }}-{{
                ConsultPriceDetail.ConsultPrice.DateEnd
              }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="基础价格">
          <el-row>
            <el-col
              :span="7"
              v-for="item in ConsultPriceDetail.ConsultPriceSubList"
              v-bind:key="item.DataType"
            >
              <p style="margin: 0">
                {{
                  item.DataType == 0
                    ? "强度等级"
                    : item.DataType == 10
                    ? "特殊材料"
                    : "浇筑方式"
                }}
              </p>
              <el-table :data="item.PriceSubDataBase" border>
                <el-table-column
                  prop="DataName"
                  label="产品名称"
                ></el-table-column>
                <el-table-column prop="DataType" label="单位"></el-table-column>
                <el-table-column label="单价(￥)">
                  <template slot-scope="scope">
                    {{ scope.row.Price }}
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          {{ ConsultPriceDetail.ConsultPrice.Remark }}
        </el-form-item>
      </el-form>
    </el-dialog>

    <GetSysOrgDialog
      :visibleDialog="visibleDialog"
      @DialogVisibleChange="dialogVisibleChange"
      @callback="dialogCallback"
    ></GetSysOrgDialog>
  </section>
</template>

<script>
//引入consultPrice.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/consultPrice";
import { getClientListPage } from "../../api/client";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// import TableDataDialog from "../../components/TableDataDialog";
import GetSysOrgDialog from "../../components/getSysOrg";

export default {
  components: { Toolbar, GetSysOrgDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      consultPrice: [],
      consultPriceBaseData: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        ConsultPrice: {
          Title: "",
          Code: "",
          DateStart: "",
          DateEnd: "",
          Remark: "",
          OrgCode: "",
          OrgId: "",
          Status: 0,
        },
        PriceBaseDataViewModels: [],
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        ConsultPrice: {
          Title: "",
          Code: "",
          DateStart: "",
          DateEnd: "",
          Remark: "",
          OrgCode: "",
          OrgId: "",
        },
        //ConsultPrice:{},
        PriceBaseDataViewModels: [],
      },
      histryData: [], //历史记录
      histrytotal: 0, //历史记录翻页
      histrypage: 1,
      histrypageSize: 20,
      histryShow: false,
      isShowConsultPriceDetailPage: false,
      ConsultPriceDetail: {
        ConsultPrice: {},
        ConsultPriceSubList: [],
      },
      visibleDialog: false,
      usePumpItemValue: 0,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //弹窗状态改变
    dialogVisibleChange(value) {
      this.visibleDialog = value;
    },
    //时间选择
    pickerDate(value, value2) {},
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getConsultPrice();
    },
    //获取岗位列表
    getConsultPrice() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getConsultPriceListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.consultPrice = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteConsultPrice(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getConsultPrice();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({
        ConsultPrice: row,
      });
      api
        .getConsultPriceBaseData({
          id: row.Id,
        })
        .then((res) => {
          if (res.data.success) {
            this.consultPriceBaseData = res.data.response;
          }
        });
    },
    //显示新增界面
    handleAdd() {
      let para = {
        id: "",
      };
      api.getConsultPriceBaseData(para).then((res) => {
        if (res.data.success) {
          this.consultPriceBaseData = res.data.response;
        }
      });
      //console.log(this.consultPriceBaseData);
      this.addFormVisible = true;
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          this.editForm.PriceBaseDataViewModels = this.consultPriceBaseData;
          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (
            (this.editForm.ConsultPrice.IsUpdateGradePrice != undefined &&
              this.editForm.ConsultPrice.IsUpdateGradePrice == 1) ||
            (this.editForm.ConsultPrice.IsUpdateSpecMtlPrice != undefined &&
              this.editForm.ConsultPrice.IsUpdateSpecMtlPrice == 1) ||
            (this.editForm.ConsultPrice.IsUpdatePouringMethodPrice !=
              undefined &&
              this.editForm.ConsultPrice.IsUpdatePouringMethodPrice == 1)
          ) {
            var info = "";
            if (
              this.editForm.ConsultPrice.IsUpdateGradePrice != undefined &&
              this.editForm.ConsultPrice.IsUpdateGradePrice == 1
            ) {
              info += "[强度等级]";
            }
            if (
              this.editForm.ConsultPrice.IsUpdateSpecMtlPrice != undefined &&
              this.editForm.ConsultPrice.IsUpdateSpecMtlPrice == 1
            ) {
              info += "[特殊材料]";
            }
            if (
              this.editForm.ConsultPrice.IsUpdatePouringMethodPrice !=
                undefined &&
              this.editForm.ConsultPrice.IsUpdatePouringMethodPrice == 1
            ) {
              info += "[浇筑方式]";
            }
            this.$confirm(
              "此操作将对" +
                this.editForm.ConsultPrice.DateStart +
                "到" +
                this.editForm.ConsultPrice.DateEnd +
                "是时间内发货单" +
                info +
                "价格进行修改,此操作可能耗时较久, 是否继续?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(() => {
                api
                  .editConsultPrice(para)
                  .then((res) => {
                    if (res && res.data && res.data.success) {
                      this.$message({
                        message: res.data.msg,
                        type: "success",
                      });
                      this.$refs["editForm"].resetFields();
                      this.editFormVisible = false;
                      this.getConsultPrice();
                    } else {
                      this.$message({
                        message: res.data.msg,
                        type: "error",
                      });
                    }
                  })
                  .finally(() => {
                    this.editLoading = false;
                  });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "操作取消",
                });
                this.addLoading = false;
                 this.editLoading = false;
              });
          } else {
            api
              .editConsultPrice(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getConsultPrice();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.editLoading = false;
              });
          }
        }
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          // this.addForm.ConsultPrice = { Title: "12" };
          this.addForm.PriceBaseDataViewModels = this.consultPriceBaseData;
          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addConsultPrice(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getConsultPrice();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //翻页事件绑定方法
    histryCurrentChange(val) {
      this.histrypage = val;
      this.getHistry();
    },
    //获取历史列表
    getHistry() {
      let para = {
        page: this.histrypage,
        key: this.currentRow.Code,
        intPageSize: this.histrypageSize,
      };
      this.listLoading = true;
      api.getHistryByPage(para).then((res) => {
        this.histrytotal = res.data.response.dataCount;
        this.histryData = res.data.response.data;
        this.listLoading = false;
      });
    },
    //查看历史列表
    handleHistry() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      this.histryShow = true;
      this.getHistry();
    },
    //切换分页大小绑定方法
    histrySizeChange(size) {
      this.histrypageSize = size;
      this.getHistry();
    },
    // 显示窗口
    handleDetail(row) {
      this.ConsultPriceDetail.ConsultPrice = row;
      api
        .getConsultPriceBaseData({
          id: row.Id,
        })
        .then((res) => {
          if (res.data.success) {
            this.ConsultPriceDetail.ConsultPriceSubList = res.data.response;
          }
        });
      this.isShowConsultPriceDetailPage = !this.isShowConsultPriceDetailPage;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.page = 1;
      this.pageSize = size;
      this.getConsultPrice();
    },
    dialogCallback(data) {
      this.addForm.ConsultPrice.OrgName = data.Name;
      this.addForm.ConsultPrice.OrgCode = data.OrgCode;
      this.addForm.ConsultPrice.OrgID = data.Id;
      this.editForm.ConsultPrice.OrgCode = data.OrgCode;
      this.editForm.ConsultPrice.OrgID = data.Id;
      this.editForm.ConsultPrice.OrgName = data.Name;
      this.visibleDialog = false;
    },
    getConsultPriceBaseData(params) {
      return getConsultPriceBaseData(params);
    },
    queryData(params) {
      return getClientListPage(params);
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
    changePumpItemValue() {
      let thisList = this.consultPriceBaseData.filter((k) => k.DataType == 20);
      if (thisList != null && thisList.length > 0) {
        let usePumpItemValue = this.usePumpItemValue;
        thisList[0].PriceSubDataBase.map((z) => (z.Price = usePumpItemValue));
        this.consultPriceBaseData.map((k) => {
          if (k.DataType == 20) {
            k.PriceSubDataBase = thisList[0].PriceSubDataBase;
          }
        });
      }
    },
  },
  mounted() {
    this.getConsultPrice();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped></style>
